class Header {
    header = document.querySelector('.site-header')
    headerNavItems = this.header?.querySelectorAll('.header-nav .item')
    menu = this.header?.querySelector('.menu-wrapper')
    menuItems = this.menu?.querySelectorAll('.menu-item')
    menuNavItems = this.menu?.querySelectorAll('.menu-nav .item')
    menuLinks = this.menu?.querySelectorAll('.links')
    menuButtons = this.menu?.querySelectorAll('.btn')
    hideOutside = this.header?.querySelectorAll('.hide-outside')
    languageSwitcher = this.header?.querySelector('.nav-wrapper .language-toggler')
    languageSwitchers = document.querySelectorAll('.language-toggler')
    toggleMenuButton = this.header?.querySelector('.mobile-menu-button')
    toggleMenuButtonIcon = this.toggleMenuButton?.querySelector('use')
    menuItemOpenSpeed = 150
    prevPosition = 0
    opened = false
    nav = {
        'home': 'menu-personal',
        'private-banking': 'menu-personal',
        'faq': 'menu-personal',
        'opacc': 'menu-personal',
        'services': 'menu-personal',
        'investments': 'menu-personal',
        'etfs-list': 'menu-personal',
        'etf-product': 'menu-personal',
        'etf-deposit': 'menu-personal',
        'business': 'menu-business',
        'fintech': 'menu-business',
        'entr': 'menu-business',
        'connectApp': 'menu-app',
        'fees': 'menu-fees',
        'loyalty': 'menu-loyalty',
        'vip': 'menu-loyalty',
        'vcc': 'menu-loyalty',
        'frontaliers': 'menu-loyalty',
        'company': 'menu-about',
        'group': 'menu-about',
        'structure': 'menu-about',
        'reports': 'menu-about',
        'news': 'menu-about',
        'tecon': 'menu-about',
        'docs': 'menu-about',
        'offices': 'menu-about',
        'contact': 'menu-about'
    }

    constructor() {
        this.init()
    }

    init() {
        const currentLang = document.querySelector('html').getAttribute('lang')
        let timer

        this.languageSwitchers?.forEach(item => {
            const links = item.querySelectorAll('.list-item')

            links.forEach(item => {
                if (item.getAttribute('href') === `?lang=${currentLang}`) {
                    item.classList.add('active')
                }
            })
        })

        this.headerNavItems?.forEach(item => {
            item.addEventListener('mouseenter', () => {
                if (timer) {
                    clearTimeout(timer)
                }

                timer = setTimeout(() => {
                    const id = item.dataset.menu

                    this.openMenuItem(id)
                }, this.menuItemOpenSpeed)
            })

            item.addEventListener('mouseleave', () => {
                if (timer) {
                    clearTimeout(timer)
                }
            })
        })

        this.menuNavItems?.forEach(item => {
            item.addEventListener('click', () => {
                const id = item.dataset.menu

                this.openMenuItem(id)
            })
        })

        this.hideOutside?.forEach(item => {
            item.addEventListener('mouseenter', () => {
                clearTimeout(timer)
            })
            item.addEventListener('mouseleave', () => {
                timer = setTimeout(() => {
                    if (window.innerWidth >= 1280) {
                        this.closeMenu()
                    }
                }, this.menuItemOpenSpeed)
            })
        })

        this.menuLinks?.forEach(item => {
            const header = item.querySelector('.header')
            const links = item.querySelectorAll('a')

            item.state = item.classList.contains('show')

            header.addEventListener('click', () => {
                const newState = !item.state

                if (newState) {
                    item.classList.add('show')
                } else {
                    item.classList.remove('show')
                }

                item.state = newState
            })

            for (const link of links) {
                link.addEventListener('click', () => {
                    this.closeMenu()
                })
            }
        })

        window.addEventListener('scroll', this.calculateScroll.bind(this))

        this.toggleMenuButton.addEventListener('click', this.toggleMenu.bind(this))

        this.prevPosition = window.scrollY
        this.calculateScroll()
        this.activePage()
    }

    calculateScroll() {
        const position = window.scrollY

        if (position > 20) {
            this.header.classList.add('scroll')

            if (position - this.prevPosition >= 5) {
                this.header.classList.add('hide')
            } else if (this.prevPosition - position >= 5) {
                this.header.classList.remove('hide')
            }
        } else {
            this.header.classList.remove('scroll')
            this.header.classList.remove('hide')
        }

        this.prevPosition = position
    }

    hideHeader() {
        // Add 'hide' class to header / Добавляем класс 'hide' к заголовку
        this.header.classList.add('hide');

        // Create a custom event 'headerHidden' with details / Создаем пользовательское событие 'headerHidden' с деталями
        const event = new CustomEvent('headerHidden', {
            detail: {
                header: this.header, // Reference to the header element / Ссылка на элемент заголовка
                timestamp: Date.now() // Timestamp of the event / Временная метка события
            }
        });

        // Dispatch the custom event on the document so it can be tracked elsewhere / Вызываем пользовательское событие на document, чтобы его можно было отследить в другом месте
        document.dispatchEvent(event);
    }

    openMenu(preventScroll) {
        this.header.classList.add('menu-opened')
        this.menu.style.display = 'block'
        this.toggleMenuButtonIcon.setAttribute('href', '#header-close-icon')
        this.opened = true

        if (preventScroll) {
            document.body.classList.add('prevent-scroll')
        }
    }

    closeMenu() {
        this.header.classList.remove('menu-opened')
        this.menu.style.display = 'none'
        this.toggleMenuButtonIcon.setAttribute('href', '#header-menu-icon')
        this.opened = false

        this.headerNavItems?.forEach(item => {
            item.classList.remove('active')
        })

        document.body.classList.remove('prevent-scroll')
    }

    toggleMenu() {
        this.opened ? this.closeMenu() : this.openMenu(true)
    }

    openMenuItem(id, open = true) {
        this.menuItems?.forEach(item => {
            if (item.id === id) {
                item.classList.add('active')
            } else {
                item.classList.remove('active')
            }
        })

        if (open) {
            this.headerNavItems?.forEach(item => {
                if (item.dataset.menu === id) {
                    item.classList.add('active')
                } else {
                    item.classList.remove('active')
                }
            })
        }

        this.menuNavItems?.forEach(item => {
            if (item.dataset.menu === id) {
                item.classList.add('active')
            } else {
                item.classList.remove('active')
            }
        })

        if (open) {
            this.openMenu()
        }
    }

    activePage() {
        const body = document.body

        for (const className in this.nav) {
            if (body.classList.contains(className)) {
                const menu = this.nav[className]

                this.headerNavItems?.forEach(item => {
                    if (item.dataset.menu === menu) {
                        item.classList.add('current')
                    } else {
                        item.classList.remove('current')
                    }
                })

                this.openMenuItem(menu, false)

                break
            }
        }
    }
}

const headerController = new Header()